export enum UserActivationActionType {
  Activate = 'activate',
  Deactivate = 'deactivate',
}
